import { TABS } from '../constants.ts';

export const getTabIndexFromPath = (currentPath: string): number => {
  const tab = TABS.find(tab => tab.path === currentPath);

  return tab ? tab.index : 0;
};

export const getTabPathFromIndex = (index: number): string => {
  const tab = TABS.find(tab => tab.index === index);

  return tab ? tab.path : '';
};

export const getLastPathSegment = (pathname: string): string => {
  return pathname.split('/').pop() || '';
};

export const getActiveTab = (pathname: string) => {
  const currentPath = getLastPathSegment(pathname);

  return TABS.find(tab => tab.path === currentPath) ?? TABS[0];
};
